import React, {useState} from 'react';
import {withI18n, WithI18nProps} from '@shopify/react-i18n';
import {Button} from '@shopify/polaris';
import {ExpertCard} from '../expert-card';
import {GetProfilesQueryData} from '../../sections/expert-index/graphql/GetProfilesQuery.graphql';
import {Routes} from '../../utilities';
import i18nArgs from './locales';

import styles from './InviteExpertCard.scss';

interface OwnProps {
  profile: GetProfilesQueryData.ProfilesEdgesNode;
  serviceHandle: string;
  invited: boolean;
  onInviteExpert(businessName: string): void;
}

type CombinedProps = OwnProps & WithI18nProps;

function InviteExpertCard({
  profile: {
    businessName,
    image,
    address,
    startingPrice,
    serviceMetrics,
    handle,
  },
  serviceHandle,
  onInviteExpert,
  invited,
  i18n,
}: CombinedProps) {
  const [loading, setLoading] = useState(false);

  const handleOnClick = () => {
    onInviteExpert(handle);
    setLoading(true);
  };

  return (
    <div className={styles.InviteExpertCard}>
      <ExpertCard
        businessName={businessName}
        profileImage={image}
        address={address}
        startingPrice={startingPrice}
        jobsCompleted={serviceMetrics.totalJobsCompleted}
        overallRating={
          serviceMetrics &&
          serviceMetrics.averageRating &&
          serviceMetrics.averageRating
        }
        totalReviews={serviceMetrics.totalReviews}
        link={Routes.profileServiceListingPath(handle, serviceHandle)}
        external
      />
      <div className={styles.ButtonContainer}>
        <Button
          onClick={handleOnClick}
          loading={loading && !invited}
          disabled={invited}
        >
          {invited
            ? i18n.translate('InviteExpertCard.buttonDisabledText')
            : i18n.translate('InviteExpertCard.buttonText')}
        </Button>
      </div>
    </div>
  );
}

export default withI18n(i18nArgs)(InviteExpertCard);
